module.exports = __webpack_public_path__ + "static/media/findCounsellor.8e49fd1a.svg";